import { store } from "../store"

export const setPage = (page: Record<string, any>) => {
  store.state.page = page
}

export const getCurrentPage = () => store.state.page
